module.exports = __webpack_public_path__ + "img/imagen1.0e71b942.png";